"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANCEL_KEYS = void 0;
/**
 * The global unique key to store the cancel token in the request config.
 */
var CANCEL_KEYS = exports.CANCEL_KEYS = '__docs_http_cancel_key__';